



















/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Vue } from 'vue-property-decorator';

/* ----------------------------------------
     Sections
 ---------------------------------------- */

import CallToAction from '@part/generic/CallToAction.vue';
import CaseOverview from '@part/generic/CaseOverview.vue';
import Logos from '@part/generic/Logos.vue';
import RelatedPages from '@part/generic/RelatedPages.vue';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({

    components: {
        CallToAction,
        CaseOverview,
        Logos,
        RelatedPages
    },

    computed: {
        content() {
            return this.template('work');
        }
    }

})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class Work extends Vue {}

